import { render } from "./HowItWorksValuesComponent.vue?vue&type=template&id=850b0796"
import script from "./HowItWorksValuesComponent.vue?vue&type=script&lang=js"
export * from "./HowItWorksValuesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__